import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { separateMarginAndPaddingProps } from '../theme/utils/spacing.js';
import { baseStyles } from './Block.baseStyles.js';
import '../../reset/HtmlA/HtmlA.js';
import '../../reset/HtmlButton/HtmlButton.js';
import { HtmlDivWithNativeRef } from '../../reset/HtmlDiv/HtmlDiv.js';
import '../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../reset/HtmlH/HtmlH.js';
import '../../reset/HtmlInput/HtmlInput.js';
import '../../reset/HtmlLabel/HtmlLabel.js';
import '../../reset/HtmlLegend/HtmlLegend.js';
import '../../reset/HtmlLi/HtmlLi.js';
import '../../reset/HtmlNav/HtmlNav.js';
import '../../reset/HtmlOl/HtmlOl.js';
import '../../reset/HtmlSpan/HtmlSpan.js';
import '../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../reset/HtmlUl/HtmlUl.js';
import '../../reset/HtmlTable/HtmlTable.js';
import '../../reset/HtmlTable/HtmlTableCaption.js';
import '../../reset/HtmlTable/HtmlTableHeader.js';
import '../../reset/HtmlTable/HtmlTableRow.js';
import '../../reset/HtmlTable/HtmlTableBody.js';
import '../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../theme/SpacingProvider/SpacingProvider.js';
import { filterDuplicateKeys } from '../../utils/common/common.js';

var baseClassName = 'fi-block';
var SemanticBlock = function (_super) {
  __extends(SemanticBlock, _super);
  function SemanticBlock() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SemanticBlock.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      variant = _b.variant,
      forwardedRef = _b.forwardedRef,
      rest = __rest(_b, ["className", "variant", "forwardedRef"]);
    var _c = separateMarginAndPaddingProps(rest),
      passProps = _c[1];
    var ComponentVariant = !variant || variant === 'default' ? HtmlDivWithNativeRef : variant;
    return /*#__PURE__*/React.createElement(ComponentVariant, __assign({
      ref: forwardedRef
    }, passProps, {
      className: classnames(baseClassName, className, (_a = {}, _a["".concat(baseClassName, "--").concat(variant)] = !!variant, _a))
    }));
  };
  return SemanticBlock;
}(Component);
var StyledBlock = styled(function (_a) {
  _a.theme;
    var variant = _a.variant;
    _a.globalMargins;
    var passProps = __rest(_a, ["theme", "variant", "globalMargins"]);
  return /*#__PURE__*/React.createElement(SemanticBlock, __assign({
    variant: variant
  }, passProps));
}).withConfig({
  componentId: "sc-oassdj-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    variant = _a.variant,
    rest = __rest(_a, ["theme", "globalMargins", "variant"]);
  var _b = separateMarginAndPaddingProps(rest),
    spacingProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.textInput, spacingProps);
  return baseStyles(theme, variant, cleanedGlobalMargins, spacingProps);
});
var Block = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledBlock, __assign({
        theme: suomifiTheme,
        globalMargins: margins,
        forwardedRef: ref
      }, props));
    });
  });
});
Block.displayName = 'Block';
var templateObject_1;

export { Block };
//# sourceMappingURL=Block.js.map
